import { useImageAnnotatorContext } from "@msuite/image-annotator";
import type { PolygonAnnotation } from "@msuite/utils/types";
import { useTranslation } from "../../../localization";
import { Slider } from "../../../slider";
import { AnnotationColorSwatch } from "./annotation-color-swatch";

export function AnnotationToolbarSubMenuStroke() {
	/** Context */
	const context = useImageAnnotatorContext();
	const selectedAnnotation = context.controller.getSelectedAnnotation() as PolygonAnnotation;

	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!selectedAnnotation) return null;

	/** Render */
	return (
		<div className="flex flex-col gap-3">
			<div className="flex flex-col gap-1">
				<div className="flex flex-row justify-between items-center **:text-white! text-xs">
					<p>{t("image_annotator.stroke_width")}</p>
					<p>{selectedAnnotation.strokeWidth.toFixed(2)}px</p>
				</div>
				<Slider
					className="w-full"
					min={0}
					max={10}
					value={[selectedAnnotation.strokeWidth ?? 1]}
					onChange={([value]) => {
						context.controller.handleOnUpdateSelection({ strokeWidth: value });
					}}
				/>
			</div>
			<AnnotationColorSwatch
				value={selectedAnnotation.strokeColor}
				onChange={(value) => context.controller.handleOnUpdateSelection({ strokeColor: value })}
			/>
		</div>
	);
}
